let prefetched = false;

/** Warm the Services route chunk on nav hover (animations still load on demand). */
export function prefetchServicesRoute() {
  if (prefetched || typeof window === 'undefined') return;
  prefetched = true;
  import('../components/services/Services');
}
